import React from 'react';
import './splashAndDine.css'

const SplashAndDine = () => {
  return (
    <div className='splash-dine-container'>
      <div className='splash-dine-wrapper'>
        <p>
          Our pristine swimming pool is the centerpiece of relaxation and fun at Brand Hotel Dodoma. Open to both adults and children. It is the perfect spot to cool off and enjoy a day in the sun. The pool area is designed for comfort, with loungers and shaded spots to relax between dips. For our younger guests, the fun does not stop at the pool!
          Kids can let loose at our <strong>Mini Water Slide</strong>, designed to deliver safe, thrilling splashes. Beyond the water, children can enjoy our <strong>Swings</strong> and <strong>Trampoline</strong>, offering endless entertainment in a secure, family-friendly environment. It is a mini adventure park that keeps the little ones smiling all day long. 
        </p>
        <ul>
          <li><strong>Adults: </strong>10,000 Tsh for full access to the pool. </li>
          <li><strong>Kids: </strong>5,000 Tsh, including pool access, mini water slide, swings, and trampoline.</li>
        </ul>
      <h2> Dine and Unwind </h2>
        <p>
          After a refreshing swim, head to our Brand Hotel Dodoma Restaurant, where culinary delights await. Our menu features a variety of mouthwatering dishes, from local Tanzanian favorites to international classics, crafted with fresh ingredients to satisfy every palate. Whether you are craving a hearty meal or a light snack, our restaurant offers a welcoming atmosphere with attentive service. 
        </p>
        
        <p>
          For those seeking a more laid-back vibe, our lounge is the perfect place to relax. Sip on a refreshing cocktail, enjoy a mocktail, or indulge in a selection of premium beverages while soaking in the serene ambiance. With cozy seating and design, the lounge is ideal for unwinding after a day of fun or catching up with friends. 
        </p>

        <br/><br/>

        <p>
          No reservations are required for day visits, but we recommend booking in advance for larger groups to ensure a seamless experience. Our facilities are open daily from 8 AM to 6 PM, giving you plenty of time to enjoy all we have to offer. 
        </p>
      </div>
    </div>
  )
}

export default SplashAndDine